<script lang="ts" setup>
import type { PropType } from '@vue/runtime-core';

const isOpened = defineModel<boolean>('isOpened', {
  type: Boolean as PropType<boolean>,
  default: false
});
</script>

<template>
  <EventsSideSheet
    v-model:isOpened="isOpened"
    :company-id="null"
    :issue-id="null"
  />
</template>
